export const mockResellerUser = {
  id: "RSL-20240312",
  name: "Jessica Chen",
  handle: "@jessicafinds",
  platform: "TikTok",
  email: "jessica@example.com",
  paypalEmail: "jessica.paypal@example.com",
  avatar: "https://public.readdy.ai/ai/img_res/af8af66ea58178eb5af25abc4136ffd8.jpg",
  joinDate: "Jan 15, 2024",
  status: "Approved",
  tier: "Gold Reseller",
  referralCode: "JESSICA2024",
};

export const mockResellerStats = {
  totalSales: 1284,
  totalCommission: 18420,
  pendingPayout: 3240,
  paidOut: 15180,
  thisMonthSales: 214,
  thisMonthCommission: 4200,
  conversionRate: 6.8,
  totalClicks: 18900,
};

export const mockCommissionByFactory = [
  {
    id: "FAC001",
    name: "Tennessee Hardwood Furniture Co.",
    country: "USA",
    category: "Furniture",
    commission: 12,
    sales: 48,
    earned: 2880,
    logo: "https://readdy.ai/api/search-image?query=hardwood%20furniture%20factory%20logo%20badge%2C%20clean%20minimal%20design%2C%20warm%20wood%20tones%2C%20professional%20brand%20mark%2C%20white%20background&width=80&height=80&seq=fac1&orientation=squarish",
  },
  {
    id: "FAC002",
    name: "Montana Organic Honey Farm",
    country: "USA",
    category: "Food & Organic",
    commission: 18,
    sales: 132,
    earned: 3960,
    logo: "https://readdy.ai/api/search-image?query=organic%20honey%20farm%20logo%20badge%2C%20golden%20honeycomb%20design%2C%20clean%20minimal%2C%20professional%20brand%20mark%2C%20white%20background&width=80&height=80&seq=fac2&orientation=squarish",
  },
  {
    id: "FAC003",
    name: "Quebec Maple Furniture",
    country: "Canada",
    category: "Furniture",
    commission: 10,
    sales: 29,
    earned: 1450,
    logo: "https://readdy.ai/api/search-image?query=canadian%20maple%20furniture%20factory%20logo%20badge%2C%20maple%20leaf%20design%2C%20clean%20minimal%2C%20professional%20brand%20mark%2C%20white%20background&width=80&height=80&seq=fac3&orientation=squarish",
  },
  {
    id: "FAC004",
    name: "Texas Leather Goods Studio",
    country: "USA",
    category: "Leather & Accessories",
    commission: 22,
    sales: 67,
    earned: 4690,
    logo: "https://readdy.ai/api/search-image?query=leather%20goods%20studio%20logo%20badge%2C%20western%20style%20design%2C%20clean%20minimal%2C%20professional%20brand%20mark%2C%20white%20background&width=80&height=80&seq=fac4&orientation=squarish",
  },
  {
    id: "FAC005",
    name: "Nova Scotia Blueberry Farm",
    country: "Canada",
    category: "Food & Organic",
    commission: 15,
    sales: 88,
    earned: 2640,
    logo: "https://readdy.ai/api/search-image?query=blueberry%20farm%20logo%20badge%2C%20fresh%20berry%20design%2C%20clean%20minimal%2C%20professional%20brand%20mark%2C%20white%20background&width=80&height=80&seq=fac5&orientation=squarish",
  },
  {
    id: "FAC006",
    name: "Colorado Outdoor Gear Factory",
    country: "USA",
    category: "Outdoor & Sports",
    commission: 14,
    sales: 54,
    earned: 2268,
    logo: "https://readdy.ai/api/search-image?query=outdoor%20gear%20factory%20logo%20badge%2C%20mountain%20adventure%20design%2C%20clean%20minimal%2C%20professional%20brand%20mark%2C%20white%20background&width=80&height=80&seq=fac6&orientation=squarish",
  },
];

export const mockReferralLinks = [
  {
    id: "RL001",
    product: "Montana Organic Wildflower Honey 12-Pack",
    factory: "Montana Organic Honey Farm",
    url: "https://crownprimemall.com/p/honey-12pack?ref=JESSICA2024",
    clicks: 4820,
    sales: 132,
    commission: 18,
    earned: 3960,
    platform: "TikTok",
  },
  {
    id: "RL002",
    product: "Tennessee Solid Oak Dining Table",
    factory: "Tennessee Hardwood Furniture Co.",
    url: "https://crownprimemall.com/p/oak-dining?ref=JESSICA2024",
    clicks: 2340,
    sales: 48,
    commission: 12,
    earned: 2880,
    platform: "Instagram",
  },
  {
    id: "RL003",
    product: "Texas Hand-Stitched Leather Wallet",
    factory: "Texas Leather Goods Studio",
    url: "https://crownprimemall.com/p/leather-wallet?ref=JESSICA2024",
    clicks: 6100,
    sales: 67,
    commission: 22,
    earned: 4690,
    platform: "Douyin",
  },
  {
    id: "RL004",
    product: "Colorado Summit Hiking Backpack",
    factory: "Colorado Outdoor Gear Factory",
    url: "https://crownprimemall.com/p/summit-pack?ref=JESSICA2024",
    clicks: 3200,
    sales: 54,
    commission: 14,
    earned: 2268,
    platform: "YouTube",
  },
];

export const mockPayoutHistory = [
  { id: "PAY001", date: "Mar 1, 2024", amount: 4200, method: "PayPal", status: "Completed", period: "Feb 2024" },
  { id: "PAY002", date: "Feb 1, 2024", amount: 3800, method: "PayPal", status: "Completed", period: "Jan 2024" },
  { id: "PAY003", date: "Jan 1, 2024", amount: 3600, method: "PayPal", status: "Completed", period: "Dec 2023" },
  { id: "PAY004", date: "Dec 1, 2023", amount: 3580, method: "PayPal", status: "Completed", period: "Nov 2023" },
];

export const mockSalesActivity = [
  { date: "Apr 1", sales: 18, commission: 420 },
  { date: "Apr 2", sales: 24, commission: 560 },
  { date: "Apr 3", sales: 15, commission: 340 },
  { date: "Apr 4", sales: 31, commission: 720 },
  { date: "Apr 5", sales: 28, commission: 650 },
  { date: "Apr 6", sales: 22, commission: 510 },
  { date: "Apr 7", sales: 35, commission: 820 },
];
